import { useEffect, useState } from "react";

// Wait for a paint and an idle slot after the primary data is ready.
export function useDeferredWork(ready: boolean) {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!ready || enabled) return;
    let idle: number | undefined;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const frame = requestAnimationFrame(() => {
      if ("requestIdleCallback" in window) {
        idle = window.requestIdleCallback(() => setEnabled(true), { timeout: 1000 });
      } else {
        timer = setTimeout(() => setEnabled(true), 0);
      }
    });
    return () => {
      cancelAnimationFrame(frame);
      if (idle !== undefined) window.cancelIdleCallback(idle);
      if (timer !== undefined) clearTimeout(timer);
    };
  }, [ready, enabled]);
  return enabled;
}